import { ParallaxProvider } from 'react-scroll-parallax';
import './App.css';
import CustomNavbar from './CustomNavbar';
import Home from './Home';


function App() {
  return (
    <div className="App">
      <ParallaxProvider>
        <CustomNavbar></CustomNavbar>
        <Home></Home>
      </ParallaxProvider>
    </div>
  );
}

export default App;
